import type { FaireProductEntity } from "../../entity_types/product";

export const p_zfsrsq5szr: FaireProductEntity = {
  token: "p_zfsrsq5szr",
  type: "product",
  name: "Rhodonite Sphere from Peru",
  brandToken: "b_en1yij2pf6",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/e06f738e2eb112ba834d05c07a45860b897c80d98ac2cf48b22ad3be1e35c1e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/80396f8505b4c263e6685bb31109ce3917b1bd8c07455c6eadf82b3285de45f5.jpeg",
    "https://cdn.faire.com/fastly/56874b659f65cb2414080011442d756c78eef43d1d67f056c99a31ea5fa26b0a.jpeg",
    "https://cdn.faire.com/fastly/ba14d6324639fa2bd029eb5b9b6b7cbed00e0515f95c436c54ecc14fd42a9d04.jpeg",
    "https://cdn.faire.com/fastly/07a434e9f095ffea73e93c2ecd3e58cc08e9a964b1af706323841519eef351f2.jpeg",
    "https://cdn.faire.com/fastly/695fd84a6c0c9f45d088c069616509c880833b2e9dbb58fd8479c7a1b5fc683f.jpeg",
    "https://cdn.faire.com/fastly/e34bb2ed7adea4635fd77e53f0c899fb7e841977641591ab774dfbada8d64896.jpeg",
    "https://cdn.faire.com/fastly/fa8141c11254b58b751f4ed95aba5958a04aaf47ff4ce4480a83a5c2a7ae86f4.jpeg"
  ],
  priceDollars: 22.87,
  description: "The Rhodonite is a crystal of compassion that works to create emotional balance and nurture love. Stimulates and activates the heart. The rosy vibrations of Rhodonite Sphere, released uniformly in all directions, aid in dealing with deep emotional pain. Ideal for Meditation as it grounds energy and makes one feel enlightened and worthwhile. Perfect for a Crystal Grid. Makes a stunning gift for avid crystal lovers and an elegant addition to any home or crystal collection. Our beautiful, hand carved Rhodonite Sphere, sourced from Peru, is a must have item on your product range to entice your customers.\n\nSold: Per piece\nOrigin: Peru",
  tags: [],
  msrpDollars: 45.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:01.209Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
